import BaseComponent from "../../baseComponent.js";
import InternalEvent from "../../../core/constants/internalEvent.js";
// import "!style!css!./style.scss";
import "!style!css!../../../vendors/tooltipster/tooltipster-3.3.0.css";

import styles from "./style.scss";

var productionData = require('./oil_production_data.js');
const handImage = require('file!../../../img/cursor-hand.png');

export default class DottedMap extends BaseComponent {
  constructor(props) {
    super(props);
    this.defaultLegendColors = [
      '#1f77b4', '#ff7f0e', '#80D8FF', '#d62728', '#9467bd', '#8c564b',
      '#F012BE', '#7f7f7f', '#bcbd22', '#17becf', '#001f3f', '#FFDC00',
      '#FF4136', '#3D9970', '#85144b', '#e377c2', '#B10DC9', '#01FF70',
      '#43C2FF', '#BCFF7B', '#7F0C73', '#7F6A0C',
      '#33691E', '#827717', '#004D40', '#304FFE', '#AA00FF', '#FF1744',
      '#2ca02c', '#827717', '#bcbd22', '#33691E', '#FF9E80', '#FFDC00',
      '#FF4136', '#84FFFF'];

    this.time = [
      'Jan 2013',
      'Feb 2013',
      'Mar 2013',
      'Apr 2013',
      'May 2013',
      'Jun 2013',
      'Jul 2013',
      'Aug 2013',
      'Sep 2013',
      'Oct 2013',
      'Nov 2013',
      'Dec 2013',
      'Jan 2014',
      'Feb 2014',
      'Mar 2014',
      'Apr 2014',
      'May 2014',
      'Jun 2014',
      'Jul 2014',
      'Aug 2014',
      'Sep 2014',
      'Oct 2014',
      'Nov 2014',
      'Dec 2014',
      'Jan 2015',
      'Feb 2015',
      'Mar 2015',
      'Apr 2015'
    ];
    this.indicators = [];

    this.loadDependencies();
  }

  loadDependencies() {
    return new Promise((resolve, reject) => {
      try {
        require.ensure([], require => {
          require('../../../vendors/tooltipster/jquery.tooltipster-3.3.0.js');
          require('../../../vendors/chartjs/Chart-1.0.2.js');
          resolve();
        });
      }
      catch(err) {
        reject(err);
      }
    });
  }

  addIndicator(country, position, index) {
    var indicator = $("<div class='indicator' data-country='" + country + "'></div>");
    indicator.css({
      top: position.top - 38,
      left: position.left - 38,
      backgroundColor: this.defaultLegendColors[index]
    });

    $("#map").append(indicator);
    this.indicators.push(indicator);


    var legend = $("<div class='legend' data-country='" + country +
      "'><div class='color' style='background-color: " +
      this.defaultLegendColors[index] + "'></div><span>" +
      country + "</span></div>");
    $("#map-legends").append(legend);
  }

  applyVolume (position, initial) {
    var that = this;
    for (var i = 0; i < this.indicators.length; i++) {
      var target = $(this.indicators[i]);
      var country = target.attr("data-country");
      var data = $.grep(productionData.world, function (e) {
        return e[0] === country
      });
      var volume = data[0][2];
      if (volume == 0) return;
      //var scale = volume / 600 + 1;
      var scale = volume / 10000.0;
      if (scale < 0.1) scale = 0.1;
      var duration = initial ? 1000 : 300;
      target.attr("data-scale", scale);
      target.attr("data-volume", volume);
      target.css("z-index", parseInt(100 / (scale * 100)) + 10);
      apply(target, scale, duration);
    }

    function apply(target, scale, duration) {
      setTimeout(function () {
        target.css({
          "webkitTransform": "scale(" + scale + ")",
          "-moz-transform": "scale(" + scale + ")",
          "msTransform": "scale(" + scale + ")"
        });
        target.next("div.pulse-ring").css({
          "webkitTransform": "scale(" + scale + ")",
          "-moz-transform": "scale(" + scale + ")",
          "msTransform": "scale(" + scale + ")"
        });
        if (target.attr("data-country") === "United States") {
          that.usPosition = $(".indicator[data-country='United States']").position();
        }
      }, duration);
    }
  }
  renderIndicators () {
    var count = 0;
    for (var country in productionData.position) {
      this.addIndicator(country, productionData.position[country], count++);
    }
    this.applyVolume(2, true);
  }
  renderPie () {
    var data = [];
    var count = 0;
    for (var key in productionData.US) {
      if (productionData.US[key] < 40) {
        productionData.US[key] = 40
      }
      data.push({label: key, value: productionData.US[key], color: this.defaultLegendColors[count++]})
    }

    var svg = d3.select("#dotted-pie")
      .append("svg")
      .append("g");

    svg.append("g")
      .attr("class", "slices");
    svg.append("g")
      .attr("class", "labels");
    svg.append("g")
      .attr("class", "lines");

    var width = 700,
      height = 350,
      radius = Math.min(width, height) / 2;

    var pie = d3.pie()
      .sort(null)
      .value(function (d) {
        return d.value;
      });

    var arc = d3.arc()
      .outerRadius(radius * 0.8)
      .innerRadius(radius * 0.4);

    var outerArc = d3.arc()
      .innerRadius(radius * 0.9)
      .outerRadius(radius * 0.9);

    svg.attr("transform", "translate(" + width / 2 + "," + height / 2 + ")");

    var key = function (d) {
      return d.data.label;
    };

    var color = d3.scaleBand()
      .domain(["Lorem ipsum", "dolor sit", "amet", "consectetur", "adipisicing", "elit", "sed", "do", "eiusmod", "tempor", "incididunt"])
      .range(["#98abc5", "#8a89a6", "#7b6888", "#6b486b", "#a05d56", "#d0743c", "#ff8c00"]);


    change(data);

    d3.select(".randomize")
      .on("click", function () {
        change(data);
      });


    function change(data) {

      /* ------- PIE SLICES -------*/
      var slice = svg.select(".slices").selectAll("path.slice")
        .data(pie(data), key);

      slice.enter()
        .insert("path")
        .style("fill", function (d) {
          return d.data.color;
        })
        .attr("class", "slice");

      slice
        .transition().duration(1000)
        .attrTween("d", function (d) {
          this._current = this._current || d;
          var interpolate = d3.interpolate(this._current, d);
          this._current = interpolate(0);
          return function (t) {
            return arc(interpolate(t));
          };
        });

      slice.exit()
        .remove();

      /* ------- TEXT LABELS -------*/

      var text = svg.select(".labels").selectAll("text")
        .data(pie(data), key);

      text.enter()
        .append("text")
        .attr("dy", ".35em")
        .text(function (d) {
          if (d.data.value > 200) {
            var val = d.data.value + "K";
            if (d.data.value > 1000) {
              val = parseFloat((d.data.value / 1000).toFixed(2)) + "M";
            }
            return d.data.label + " (" + val + ")"
          }
          ;
        });

      function midAngle(d) {
        return d.startAngle + (d.endAngle - d.startAngle) / 2;
      }

      text.transition().duration(1000)
        .attrTween("transform", function (d) {
          this._current = this._current || d;
          var interpolate = d3.interpolate(this._current, d);
          this._current = interpolate(0);
          return function (t) {
            var d2 = interpolate(t);
            var pos = outerArc.centroid(d2);
            pos[0] = radius * (midAngle(d2) < Math.PI ? 1 : -1);
            return "translate(" + pos + ")";
          };
        })
        .styleTween("text-anchor", function (d) {
          this._current = this._current || d;
          var interpolate = d3.interpolate(this._current, d);
          this._current = interpolate(0);
          return function (t) {
            var d2 = interpolate(t);
            return midAngle(d2) < Math.PI ? "start" : "end";
          };
        });

      text.exit()
        .remove();

      /* ------- SLICE TO TEXT POLYLINES -------*/

      var polyline = svg.select(".lines").selectAll("polyline")
        .data(pie(data), key);

      polyline.enter()
        .append("polyline");

      polyline.transition().duration(1000)
        .attrTween("points", function (d) {
          if (d.data.value > 200) {
            this._current = this._current || d;
            var interpolate = d3.interpolate(this._current, d);
            this._current = interpolate(0);
            return function (t) {
              var d2 = interpolate(t);
              var pos = outerArc.centroid(d2);
              pos[0] = radius * 0.95 * (midAngle(d2) < Math.PI ? 1 : -1);
              return [arc.centroid(d2), outerArc.centroid(d2), pos];
            };
          }
        });

      polyline.exit()
        .remove();
    };

    var usTotal = $("<div class='us-total'>9.69M</div>");
    $("#dotted-pie").append(usTotal);
  }
  renderPie2 () {
    var that = this;
    var data = [];
    var count = 0;

    $("#us-breakdown-pie").show().css("opacity", 1);

    for (var key in productionData.US) {
      var color = this.defaultLegendColors[count];
      if (productionData.US[key] < 40) {
        productionData.US[key] = 40
      }
      if (this.defaultLegendColors[count++] === "#80D8FF") {
        color = "#00BCD4";
      }
      data.push({value: productionData.US[key], color: color})
      if (count == this.defaultLegendColors.length) count = 0;
    }

    var canvas = document.getElementById("us-breakdown-pie");
    canvas.width = 492;
    canvas.height = 293;

    var myPie = new Chart(canvas.getContext("2d")).Doughnut(data, {
      animationSteps: 70,
      animationEasing: 'easeInOutQuart',
      segmentShowStroke: false,
      tooltipTemplate: "<%= value %>%",
      showTooltips: true
    });


  }
  onIndicatorHoverOrTouched (e) {
    var that = this;
    var target = $(e.target).css({opacity: 1});
    var country = target.attr("data-country");
    var cursor = country === "United States" ? "pointer" : "default";

    clearTimeout(this.timeout);

    this.timeout = setTimeout(function () {
      var scale = parseFloat(target.attr("data-scale"));
      var volume = parseFloat(target.attr("data-volume"))

      if (volume > 1000) {
        volume = parseFloat((volume / 1000).toFixed(2)) + "M";
      } else {
        volume += "K"
      }

      showTooltip(target, scale, country + ": " + volume);

      that.hoveringIndicator = target;

      $(".legend[data-country='" + country + "']").addClass("select");
      $(".legend[data-country!='" + country + "']").addClass("blur");
      that.startPulsing(target, country);
    }, 100);


    function showTooltip(target, scale, content) {
      try {
        $("#tooltip").tooltipster('destroy');
      } catch (e) {
      }
      ;
      $("#tooltip")
        .css({
          top: $(target).position().top + (80 * that.mapScale * scale),
          left: $(target).position().left,
          width: 80 * that.mapScale * scale,
          height: 0,
          position: "absolute",
          opacity: 1
        })
        .tooltipster({
          position: 'bottom',
          ignoreMouse: true,
          content: content
        })
        .tooltipster("show");
    }
  }

  showUSBreakDown () {
    var that = this;
    $("#click-indicator").hide();
    this.stopPulsing();
    $("#map-legends").animate({opacity: 0}, 1000, function () {
      $("#map-legends").hide();
      $("#us-legends").css({opacity: 0}).show().animate({opacity: 1}, 1200);
    });
    var usIndicator = $(".indicator[data-country='United States']");
    var clone = usIndicator.clone();
    var scale = parseFloat($(usIndicator).attr("data-scale"));
    clone.css({
      top: usIndicator.position().top,
      left: usIndicator.position().left,
      width: 80 * that.mapScale * scale,
      height: 80 * that.mapScale * scale,
      "webkitTransform": "scale(1)",
      "-moz-transform": "scale(1)",
      "msTransform": "scale(1)"
    }).addClass("cloned");
    var animatedScale = 260 / (80 * that.mapScale * scale);
    $("#dotted-map-container").append(clone);
    $("#map").animate({opacity: 0}, 500, function () {
      var usPie = $("#dotted-pie")
      $("#dotted-pie").show(0);
      $("#dotted-pie").css("opacity", 0);
      that.renderPie();
      $("#dotted-pie").find("g.slices").css({opacity: 0});

      $(clone).css({
        "webkitTransform": "scale(" + animatedScale + ")",
        "-moz-transform": "scale(" + animatedScale + ")",
        "msTransform": "scale(" + animatedScale + ")"
      })
        .animate({
          top: usPie.position().top + 120,
          left: usPie.position().left - 60
        }, 700, function () {

          that.renderPie2();
          // setDismissEvent();
          setTimeout(function () {
            $("#dotted-pie").animate({opacity: 1}, 1000, function () {
              setDismissEvent();
            });
          }, 1000);
        });
    });

    function setDismissEvent() {
      $(document).on("click touchend", function (e) {
        if ($(e.target).parents("div#dotted-pie").length == 0 && $(e.target).parents("div#us-legends").length == 0) {
          $("#dotted-map-container").find("div.cloned").animate({opacity: 0}, 700, function () {
            $("#dotted-map-container").find("div.cloned").remove();
          });
          $("#us-breakdown-pie").animate({opacity: 0}, 1500, function () {
            $("#us-breakdown-pie").empty().hide();
          });
          $("#dotted-pie").animate({opacity: 0}, 1500, function () {
            $("#dotted-pie").empty().hide();
          });
          $("#map").animate({opacity: 1}, 1500);

          $("#map-legends").show().css({opacity: 0});
          $("#map-legends").animate({opacity: 1}, 750);
          $("#us-legends").animate({opacity: 0}, 750, function () {
            $("#us-legends").hide();
          });

          $(this).off("click touchend");
        }
      });
    }

  }

  setEvents () {
    var that = this;
    $("div.indicator").on("touchend", function (e) {
      that.touchedCountry = $(e.target).attr("data-country");
      that.onIndicatorHoverOrTouched(e);
    });

    $("div.legend span").on("touchend", function (e) {
      var country = $(this).parent().attr("data-country");
      if (country === undefined) return;
      var target = $(".indicator[data-country='" + country + "']");
      that.onIndicatorHoverOrTouched({target: target});
    });

    $("#dashboard-page-container, #dashboard-body-placeholder").on("touchend", function (e) {
      if (that.touchedCountry === "United States" && $(e.target).hasClass("indicator-pulse-ring")) {
        that.showUSBreakDown();
      } else {
        that.stopPulsing();
        if ($(e.target).hasClass("indicator")) ignoreTouch = true;
      }
    });

    $("div.indicator").on("click", function (e) {
      that.onIndicatorHoverOrTouched(e);
    });

    $(".indicator-pulse-ring").on("click", function (e) {
      var country = $(this).attr("data-country");
      if (country === "United States") {
        that.showUSBreakDown();
      }
    });

    $("div.legend").on("click", function () {
      that.stopPulsing();
      var country = $(this).attr("data-country");
      if (country === undefined) return;
      var target = $(".indicator[data-country='" + country + "']");
      that.onIndicatorHoverOrTouched({target: target});
    });

    $("#dotted-map-container").on("click", function (e) {
      if ($(e.target).attr("id") === "dotted-map-container") {
        that.stopPulsing();
      }
    });

  }
  startPulsing (target, country) {
    $(".indicator[data-country='" + country + "']").addClass("focus");
    $(".indicator[data-country!='" + country + "']").css({opacity: 0.2});
    var scale = parseFloat($(target).attr("data-scale"));
    var borderWidth = 3;
    var pulseScale = 1.2;
    var zIndex = $(target).css("z-index");

    if (scale <= 0.05) {
      borderWidth = 1;
      pulseScale = 2;
    } else if (scale < 0.3) {
      borderWidth = 2;
      pulseScale = 1.4;
    }


    var sUsrAg = navigator.userAgent;
    if (sUsrAg.indexOf("Chrome") > -1 || sUsrAg.indexOf("Safari") > -1) {
      $(".indicator-pulse-ring")[0].style.webkitAnimationName = this.changePulsateKeyframes(pulseScale, window.CSSRule.WEBKIT_KEYFRAMES_RULE);
    } else if (sUsrAg.indexOf("Opera") > -1) {
    } else if (sUsrAg.indexOf("Firefox") > -1) {
      $(".indicator-pulse-ring")[0].style.mozAnimationName = this.changePulsateKeyframes(pulseScale, window.CSSRule.MOZ_KEYFRAMES_RULE);
    } else if (sUsrAg.indexOf("MSIE") > -1) {
    }


    $(".indicator-pulse-ring").css({borderWidth: borderWidth}).attr("data-country", country);

    $(".indicator-pulse-ring").css({
      top: $(target).position().top,
      left: $(target).position().left,
      width: 80 * this.mapScale * scale,
      height: 80 * this.mapScale * scale,
      animation: "pulsate-lg 1.2s ease-out",
      animationIterationCount: "infinite",
      borderColor: $(target).css("background-color"),
      // zIndex: zIndex
    }).show();
  }

  stopPulsing () {
    try {
      $("#tooltip").tooltipster('destroy');
    } catch (e) {
    }
    ;
    $(".indicator").css({opacity: 1}).removeClass("focus");
    $(".indicator-pulse-ring").hide();
    $(".legend").removeClass("select").removeClass("blur");
  }

  changePulsateKeyframes (scale, type) {
    var sUsrAg = navigator.userAgent;
    var keyframe = findKeyframesRule("pulsate-lg", type);
    var prefix = "";
    keyframe.deleteRule("0%");
    keyframe.deleteRule("50%");
    keyframe.deleteRule("100%");

    if (type === window.CSSRule.WEBKIT_KEYFRAMES_RULE) {
      prefix = "webkit";
    } else if (type === window.CSSRule.MOZ_KEYFRAMES_RULE) {
      prefix = "moz";
    }

    if (keyframe.appendRule) {
      keyframe.appendRule("0% { -" + prefix + "-transform: scale(1); opacity: 0.0; }");
      keyframe.appendRule("50% { opacity: 1.0; }");
      keyframe.appendRule("100% { -" + prefix + "-transform: scale(" + scale + "); opacity: 0.0; }");
    } else {
      keyframe.insertRule("0% { -" + prefix + "-transform: scale(1); opacity: 0.0; }");
      keyframe.insertRule("50% { opacity: 1.0; }");
      keyframe.insertRule("100% { -" + prefix + "-transform: scale(" + scale + "); opacity: 0.0; }");
    }

    return keyframe;
  }
  renderUSLegends () {
    var count = 0;

    for (var state in productionData.US) {
      var color = this.defaultLegendColors[count];
      if (this.defaultLegendColors[count++] === "#80D8FF") {
        color = "#00BCD4";
      }

      var legend = $("<div class='legend' data-state='" + state +
        "'><div class='color' style='background-color: " +
        color + "'></div><span>" +
        state + "</span></div>");
      $("#us-legends").append(legend);
    }
  }

  componentDidMount () {
    this.touchedCountry = null;
    this.timeout = null;
    var that = this;
    var legendWidth = 750;
    $('#map').css('opacity', '0');
    $('#map-legends').css('opacity', '0');


    var windowWidth = $(window).width();
    var optWidth = windowWidth < 600 ? windowWidth : windowWidth * 0.8;

    if (windowWidth < 600) {
      var left = $("#map").position().left;
      $("#map").parent().css("margin-left", left);
    }

    that.mapScale = optWidth / 630;
    if (that.mapScale > 1.3) that.mapScale = 1.3;
    //if($(window).height <= 768) that.mapScale = 1;
    $('#map').css({
      "webkitTransform": "scale(" + that.mapScale + ")",
      "-moz-transform": "scale(" + that.mapScale + ")"
    });

    if (optWidth < 750) {
      legendWidth = parseInt(optWidth / 150) * 150;
    }

    setTimeout(function () {

      that.renderIndicators();
      that.renderUSLegends();

      $('#map').animate({opacity: 1}, 1000);
      $('#map-legends').css({
        top: 350 * that.mapScale + 20,
        width: legendWidth,
        marginLeft: -legendWidth / 2
      }).animate({opacity: 1}, 1000);

      //$('#dotted-map-container').height(300 * that.mapScale + $('#map-legends').height());
      $(window).resize();

      setTimeout(function () {
        displayClickIndicator();
        that.setEvents();
        // this.publish(InternalEvent.Dashboard.RENDERED);
      }, 2500);
    }, 1500);


    function displayClickIndicator() {
      $('#click-indicator').css({
        opacity: 0,
        top: that.usPosition.top + 45,
        left: that.usPosition.left - 7
      }).show();
      $('#click-indicator').animate({opacity: 1}, 500);

      $(".inner-ring").show();
      setTimeout(function () {
        $(".mid-ring").show();
      }, 300);
      setTimeout(function () {
        $(".outer-ring").show();
      }, 600);

      setTimeout(function () {
        $('#click-indicator').animate({opacity: 0}, 500, function () {
          $('#click-indicator').hide();
        });
      }, 6300);
    }

    this.publish(InternalEvent.App.HIDE_PRELOADER);

  }
  onTimeLineChange (index) {
    this.applyVolume(index);
  }
  render () {
    return (
      <div id="dotted-map-container" className={styles.container} style={{position: "relative", flex: "1", marginTop: "53px"}}>
        <div id="dotted-pie"></div>
        <canvas id="us-breakdown-pie"></canvas>
        <div>
          <div id="map">
            <ul>
              <li></li>
              <li></li>
              <li></li>
              <li></li>
              <li></li>
              <li></li>
              <li></li>
              <li></li>
              <li></li>
              <li></li>
              <li></li>
              <li></li>
              <li></li>
              <li></li>
              <li></li>
              <li></li>
              <li></li>
              <li></li>
              <li></li>
              <li></li>
              <li></li>
              <li></li>
              <li></li>
              <li></li>
              <li></li>
              <li></li>
              <li></li>
              <li></li>
              <li></li>
              <li></li>
              <li></li>
              <li></li>
              <li></li>
              <li></li>
              <li></li>
              <li></li>
              <li></li>
              <li></li>
              <li></li>
              <li></li>
              <li></li>
              <li></li>
              <li></li>
              <li></li>
              <li></li>
              <li></li>
              <li></li>
              <li></li>
              <li></li>
              <li></li>
              <li></li>
              <li></li>
              <li></li>
              <li></li>
              <li></li>
              <li></li>
              <li></li>
              <li></li>
              <li></li>
              <li></li>
              <li></li>
              <li></li>
              <li></li>
            </ul>

          </div>
        </div>
        <div className='indicator-pulse-ring'></div>
        <div id="tooltip" className="tooltip"></div>
        <div id="map-legends" className="legends"></div>
        <div id="us-legends" className="legends"></div>
        <div id="click-indicator">
          <div className="outer-ring"></div>
          <div className="mid-ring"></div>
          <div className="inner-ring"></div>
          <img className="hand" src={handImage} height="36" width="28"></img>
        </div>
      </div>
    );
  }
}


function findKeyframesRule(rule, type) {
  // gather all stylesheets into an array
  var ss = document.styleSheets;

  // loop through the stylesheets
  for (var i = 0; i < ss.length; ++i) {

    // loop through all the rules
    if(ss[i].cssRules != null) {
      for (var j = 0; j < ss[i].cssRules.length; ++j) {

        // find the -webkit-keyframe rule whose name matches our passed over parameter and return that rule
        if (ss[i].cssRules[j].type == type && ss[i].cssRules[j].name == rule)
          return ss[i].cssRules[j];
      }
    }

  }

  // rule not found
  return null;
}


// WEBPACK FOOTER //
// ./src/components/dashboard/dotted-map-widget/dotted-map.jsx